import { useMemo } from "react";
import { InputFieldProps } from "./types";
import { InputFieldComponent } from "./InputFieldComponent";

export const ObjectInput: React.FC<InputFieldProps> = ({ objectInput, inputField, inputValue: _inputValue, path, onUpdate, validationErrors }) => {
	if (inputField.type !== "object") {
		return <>Non-object type is not supported by this component</>;
	}

	const inputValue = useMemo(() => {
		if (_inputValue !== undefined) {
			return _inputValue;
		}

		return {};
	}, [_inputValue]);

	return (
		<div className="border border-gray-200 rounded-lg p-4 space-y-4">
			{Array.isArray(inputField.properties) &&
				inputField.properties.map((subInputField, index) => (
					<div key={index}>
						<InputFieldComponent
							objectInput={objectInput}
							inputField={subInputField}
							inputValue={inputValue}
							path={`${path}.${subInputField.name}`}
							onUpdate={(update) => onUpdate?.(update)}
							validationErrors={validationErrors}
						/>
					</div>
				))}
		</div>
	);
};
